import React from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route
} from 'react-router-dom';
import AdminProtectedRoute from './security/AdminProtectedRoute';
import Navbar from "./components/Navbar";
import FloatingUnpaidOrders from "./components/FloatingUnpaidOrders/FloatingUnpaidOrders";
import WhatsAppFloat from './components/WhatsAppFloat';
import ScrollToTop from './components/ScrollToTop';
import Layout from "./components/TopLayout";
import Homepage from './pages/homepage'
import AboutUsPage from './pages/AboutUsPage'
import ContactUsPage from './pages/ContactUsPage'
import BlogsPage from './pages/BlogsPage';
import BlogDetails from './pages/BlogDetailsPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import ShowCart from './pages/ShowCart';
import SignupLogin from './pages/SignupLoginPage';
import EventsPage from './pages/EventsPage';
import UserProfile from './pages/ProfilePage';
import WishlistPage from './pages/WishlistPage';
import SearchPage from './pages/SearchPage';
import CheckoutPage from './pages/CheckoutPage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailure from './pages/PaymentFailure';
import PaymentPending from './pages/PaymentPending';
import UserOrdersPage from './pages/UserOrdersPage';
import OrderDetailPage from './pages/OrderDetailPage';

import CMSRoot from './pages/CMS/Dashboard'
import CategoriesPage from './pages/CMS/CategoryPage';
import AddProductPage from './pages/CMS/AddProducts'
import CMSLogin from './pages/CMS/Login'
import ShowAllProducts from './pages/CMS/ShowProducts'
import AddBlog from './pages/CMS/AddBlog';
import ManageBlogs from './pages/CMS/ManageBlogs';
import EditBlogPage from './pages/CMS/EditBlogPage';
import OrdersPage from './pages/CMS/OrdersPage';
import UserManagement from './pages/CMS/UserManagement'
import CommentManagementPage from './pages/CMS/CommentManagementPage';

import AOS from 'aos';
import 'aos/dist/aos.css';
import {
    useEffect
} from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



function App() {

    useEffect(() => {

        AOS.init({
            duration: 2000,
            once: false, // Animate once only
        });

    }, []);



    return ( <
        Router >
        <
        Layout / >

        <
        WhatsAppFloat phoneNumber = "989104862425"
        defaultMessage = "سلام! می‌خواهم درباره یکی از محصولات شما سؤالی بپرسم" /
        >
        <
        FloatingUnpaidOrders / >
        <
        ScrollToTop / >
        <
        Routes > { /* Public Routes */ } <
        Route path = "/"
        element = { < Homepage / >
        }
        /> <
        Route path = "/auth"
        element = { < SignupLogin / >
        }
        /> <
        Route path = "/events"
        element = { < EventsPage / >
        }
        /> <
        Route path = "/team"
        element = { < AboutUsPage / >
        }
        /> <
        Route path = "/contact"
        element = { < ContactUsPage / >
        }
        /> <
        Route path = "/blogs"
        element = { < BlogsPage / >
        }
        /> <
        Route path = "/blogs/:slug"
        element = { < BlogDetails / >
        }
        /> <
        Route path = "/products/*"
        element = { < ProductsPage / >
        }
        /> <
        Route path = "/product/:productId"
        element = { < ProductDetailPage / >
        }
        /> <
        Route path = "/cart"
        element = { < ShowCart / >
        }
        /> <
        Route path = "/checkout"
        element = { < CheckoutPage / >
        }
        /> <
        Route path = "/profile"
        element = { < UserProfile / >
        }
        /> <
        Route path = "/orders"
        element = { < UserOrdersPage / >
        }
        /> <
        Route path = "/wishlist"
        element = { < WishlistPage / >
        }
        /> <
        Route path = "/search"
        element = { < SearchPage / >
        }
        /> <
        Route path = "/payment/success"
        element = { < PaymentSuccess / >
        }
        /> <
        Route path = "/payment/failure"
        element = { < PaymentFailure / >
        }
        /> <
        Route path = "/payment/pending"
        element = { < PaymentPending / >
        }
        /> <
        Route path = "/orders/:id"
        element = { < OrderDetailPage / >
        }
        />

        <
        Route path = "/cms"
        element = { <
            AdminProtectedRoute >
            <CMSRoot / >
            </AdminProtectedRoute>
        }
        />

        <
        Route path = "/cms/add-product"
        element = { <
            AdminProtectedRoute >
            <AddProductPage / >
            </AdminProtectedRoute>
        }
        />

        <
        Route path = "/cms/products"
        element = { <
            AdminProtectedRoute >
            <ShowAllProducts / >
            </AdminProtectedRoute>
        }
        />

        <
        Route path = "/cms/categories"
        element = { 
            <AdminProtectedRoute >
            <CategoriesPage / >
            </AdminProtectedRoute>
        }
        />

        <
        Route path = "/cms/add-blog"
        element = { <
            AdminProtectedRoute >
            <AddBlog / >
            </AdminProtectedRoute>
        }
        />

        <
        Route path = "/cms/edit-blog/:id"
        element = { <
            AdminProtectedRoute >
            <EditBlogPage / >
            </AdminProtectedRoute>
        }
        />

        <
        Route path = "/cms/manage-blogs"
        element = { <
            AdminProtectedRoute >
            <ManageBlogs / >
            </AdminProtectedRoute>
        }
        />

        <
        Route path = "/cms/orders"
        element = { <
            AdminProtectedRoute >
            <OrdersPage / >
            </AdminProtectedRoute>
        }
        />

        <
        Route path = "/cms/user-management"
        element = { <
            AdminProtectedRoute >
            <UserManagement / >
            </AdminProtectedRoute>
        }
        />

        <
        Route path = "/cms/comment-management"
        element = { <
            AdminProtectedRoute >
            <CommentManagementPage / >
            </AdminProtectedRoute>
        }
        />

        </Routes>
     </Router>

    );
}

export default App;